import { app } from '../../bootstrap/core';
import { transferState } from './transfer.state';
import { transferComponent } from './transfer.component';
import { TransferModel } from './transfer.model';

app.config(transferState);
app.component(transferComponent.name, transferComponent);
app.factory('TransferModel', () => TransferModel);




// WEBPACK FOOTER //
// ./src/app/components/transfer/transfer.js